import { render, staticRenderFns } from "./AccountPermissionGroupList.vue?vue&type=template&id=cadf6482&scoped=true"
import script from "./AccountPermissionGroupList.vue?vue&type=script&lang=js"
export * from "./AccountPermissionGroupList.vue?vue&type=script&lang=js"
import style0 from "./AccountPermissionGroupList.vue?vue&type=style&index=0&id=cadf6482&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cadf6482",
  null
  
)

export default component.exports